import * as React from 'react';

export interface IDataLoader {
    loadingText: string,
    loadingSvgText: string,
    stopAnimationText?: string,
};

interface IDataLoaderState {
    loadingText: string;
    showStopAnimationButton: boolean;
    showAnimation: boolean;
    timeout: any;
};

class DataLoader extends React.PureComponent<IDataLoader, IDataLoaderState> {
    constructor(props) {
        super(props);
        var subscriptionLoadingMessage: string;

        // In 5 seconds, give the user an option to stop the loading.
        let timeoutFunc = setTimeout(() => {
            this.setState({
                showStopAnimationButton: true,
                showAnimation: this.state.showAnimation
            });
        }, 5000);


        this.state = {
            loadingText: props.loadingText,
            showStopAnimationButton: false,
            showAnimation: true,
            timeout: timeoutFunc
        };

    }

    componentWillUnmount() {
        clearTimeout(this.state.timeout);
    }

    render() {
        const circleTag = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="25 25 50 50" xml:space="preserve"><circle class="loading-icon-path" cx= "50" cy= "50" r= "20" fill= "none" stroke- width="2" stroke- miterlimit="10"></circle></svg>';

        const loadingSvg = this.props.loadingSvgText ? this.props.loadingSvgText : circleTag;
        let loadingClass;
        if (this.state.showAnimation) {
            loadingClass = "loading-icon";
        }
        else {
            loadingClass = "loading-icon paused";
        }
        return (
            <div className="loading-container">
                <div id="loadingSvg" className={loadingClass} dangerouslySetInnerHTML={{ __html: loadingSvg }}></div>
                <div className="loading-text">
                    {this.state.loadingText ? this.state.loadingText : ""}
                </div>
                {
                    this.props.stopAnimationText ?
                        <button style={{ "visibility": this.state.showStopAnimationButton ? "visible" : "hidden" }} className="loading-stop-btn" onClick={() => this.stopLoadingAnimation()}>{this.props.stopAnimationText}</button>
                        : null
                }
            </div>
        );
    }

    private stopLoadingAnimation() {
        this.setState({
            showStopAnimationButton: false,
            showAnimation: false
        });
    }
}

export default DataLoader;